import { useTheme } from '@mui/material/styles';
import { Button } from '@mui/material';
import React, { useState } from 'react';
import { Grid, useMediaQuery } from '@mui/material';
import SectionHeader from '../../ui/SectionHeader';

import { ChannelSubscriptionCards } from './ChannelSubscriptionCards';
import ArticleList from '../../ui/ArticleList';
import { baseUrls } from '../../../utils/baseUrls.utils';
import { useHistory } from 'react-router-dom';
import { ChannelSubscriptionWithPaymentInfo } from '../../../shared/types';
import { CallToActionCard } from '../../ui/CallToActionCard';
import { CALL_TO_ACTION } from '../../../config';
import { PremiumChannels } from './ChannelsGrid/PremiumChannels';
import { FreeChannels } from './ChannelsGrid/FreeChannels';
import { ContainerNoScroll } from '../../ui/ContainerNoScroll';

export interface SubscriptionContentProps {
    hasSubscriptions: boolean;
    channelSubscriptions: ChannelSubscriptionWithPaymentInfo[];
    refetchQuerySubscriptions: () => void;
}

export const Subscriptions = ({
    hasSubscriptions,
    channelSubscriptions,
    refetchQuerySubscriptions,
}: SubscriptionContentProps) => {
    const history = useHistory();
    const theme = useTheme();
    const xsDown = useMediaQuery(theme.breakpoints.down('xs'));
    const [articleCount, setArticleCount] = useState<number>(0);

    const onArticleListLoaded = (totalCount: number) => {
        setArticleCount(totalCount);
    };

    const yourSubsHeader = (
        <SectionHeader
            title="Your subscriptions"
            sectionHeaderOffsetDisabled={true}
        />
    );

    return (
        <ContainerNoScroll>
            <Grid container spacing={8}>
                <Grid size={12}>
                    <Grid container spacing={2}>
                        {hasSubscriptions ? (
                            <>
                                <Grid size={12}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            size={{
                                                xs: 12,
                                                sm: 6,
                                            }}
                                        >
                                            {yourSubsHeader}
                                        </Grid>
                                        <Grid
                                            style={{
                                                textAlign: xsDown
                                                    ? 'left'
                                                    : 'right',
                                            }}
                                            size={{
                                                xs: 12,
                                                sm: 6,
                                            }}
                                        >
                                            <Button
                                                variant="contained"
                                                onClick={() =>
                                                    history.push(
                                                        baseUrls.emailNotifications
                                                    )
                                                }
                                            >
                                                Manage email notifications
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid size={12}>
                                    <ChannelSubscriptionCards
                                        channelSubscriptions={
                                            channelSubscriptions
                                        }
                                        onUpdate={refetchQuerySubscriptions}
                                    />
                                </Grid>
                            </>
                        ) : (
                            <>
                                <Grid size={12}>{yourSubsHeader}</Grid>
                                <Grid size={12}>
                                    <CallToActionCard
                                        title="You don’t have any subscriptions yet"
                                        subtitle="Explore the channels directory and find content that is relevant to your business."
                                        buttonText="Browse channels"
                                        buttonLink={baseUrls.channels.main}
                                        imageUrl={CALL_TO_ACTION}
                                    />
                                </Grid>
                            </>
                        )}
                    </Grid>
                </Grid>
                {hasSubscriptions ? (
                    <Grid size={12}>
                        <Grid container spacing={2}>
                            {articleCount > 0 && (
                                <Grid size={12}>
                                    <SectionHeader
                                        title="From your subscriptions"
                                        sectionHeaderOffsetDisabled
                                    />
                                </Grid>
                            )}
                            <Grid size={12}>
                                <ArticleList
                                    source="Subscriptions"
                                    onlyMySubscriptions={true}
                                    onDataLoaded={onArticleListLoaded}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                ) : (
                    <>
                        <Grid size={12}>
                            <PremiumChannels randomize quantityToDisplay={3} />
                        </Grid>
                        <Grid size={12}>
                            <FreeChannels randomize quantityToDisplay={3} />
                        </Grid>
                    </>
                )}
            </Grid>
        </ContainerNoScroll>
    );
};
